<template>
  <div id="app">
    <router-link to="/"></router-link>
    <router-view />
    <FloatSidebar />
  </div>
</template>

<script>
  import Wow  from 'wow.js'
  import { routes } from "@/router";
  import FloatSidebar from '@/components/FloatSidebar.vue';
  export default {
    components: { FloatSidebar },
    data(){
      return {
        isScroll:false,
      }
    },
    routes() {
      return routes[0].children;
    },
    created() {
      if(!window.localStorage.getItem('language')) window.localStorage.setItem('language','zh-CN');
    },
    mounted(){
      const wow = new Wow({
        boxClass: 'wow',
        animateClass: 'animate__animated',
        // 这个对应的是你的动画的前缀类名
        mobile: true,
        live: true
      })
      wow.init()

      // window.addEventListener('wheel',()=>{
      //   this.handleScroll();
      // })
    },
    methods:{
      handleScroll(){
        if(!this.isScroll){
          this.isScroll = true;
          document.body.style.overflowY = 'auto';
          setTimeout(()=>{
            this.isScroll = false;
            document.body.style.overflowY = 'hidden';
          },1000)
        }
      },
    }
  }
</script>

<style lang="scss">
  body{
    width: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden;
    // overflow-y: hidden;
    overflow-y: auto;
  }
  ::-webkit-scrollbar {
    width: 3px;
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, .5);
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, .1);
  }
</style>
